export const ApiSettingsApiTokens = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const save = async (id, payload) => {
    const result = await axios.post(`/api/settings/api-tokens/${id}`, payload)
    return result.data
  }

  const find = async (id) => {
    const result = await axios.get(`/api/settings/api-tokens/${id}`)
    return result.data
  }

  const load = async () => {
    const result = await axios.get('/api/settings/api-tokens')
    return result.data
  }

  return {
    tokensFind: find,
    tokensLoad: load,
    tokensSave: save
  }
}
